import React, { useState, useEffect } from 'react';
import './IdleWarningModal.css';

interface IdleWarningModalProps {
  isVisible: boolean;
  timeRemaining: number; // in seconds
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
  isVisible,
  timeRemaining,
  onStayLoggedIn,
  onLogout,
}) => {
  const [displayTime, setDisplayTime] = useState(timeRemaining);

  useEffect(() => {
    setDisplayTime(timeRemaining);
  }, [timeRemaining]);

  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      setDisplayTime((prev) => {
        if (prev <= 1) {
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isVisible, onLogout]);

  if (!isVisible) return null;

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="idle-warning-overlay">
      <div className="idle-warning-modal">
        <div className="idle-warning-header">
          <div className="idle-warning-icon">⏰</div>
          <h2>Session Timeout Warning</h2>
        </div>
        
        <div className="idle-warning-content">
          <p>
            You will be automatically logged out due to inactivity in:
          </p>
          <div className="countdown-timer">
            {formatTime(displayTime)}
          </div>
          <p className="warning-message">
            Click "Stay Logged In" to continue your session.
          </p>
        </div>

        <div className="idle-warning-actions" style={{display:'flex', gap: '5px'}}>
          <button
            className="btn-primary"
            onClick={onStayLoggedIn}
          >
            Stay Logged In
          </button>
          <button
            style={{paddingLeft: '8px', paddingRight: '8px'}}
            onClick={onLogout}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};
